<script lang="ts">
	import type { ICoinInfo } from 'customTypes/coinDetails';
	import { _ } from 'utils/i18/i18n';

	export let dark: boolean;
	export let name: string;
	export let coinInfo: ICoinInfo;
</script>

<div class="wrapper" class:dark>
	<h2 class="title" id="fees">{`About ${name?.toUpperCase()}`}</h2>

	<div class="info-wrapper">
		<ul class="left-side">
			<li class="text">
				{$_('coinDetailed.coinAbout.category')} <span class="value">{coinInfo.categories}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.coinType')} <span class="value">{coinInfo.coinType}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.proof')} <span class="value">{coinInfo.proof}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.hash')} <span class="value">{coinInfo.hash}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.totalSupply')}
				<span class="value">{coinInfo.totalSupply ?? '-'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.holders')}
				<span class="value">{coinInfo.holders ?? '-'}</span>
			</li>
		</ul>
		<ul class="center-side">
			<li class="text">
				{$_('coinDetailed.coinAbout.inflation')}
				<span class="value dots">{coinInfo.inflation}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.hardCap')}
				<span class="value">{coinInfo.hardCap ?? '-'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.mineable')}
				<span class="value">{coinInfo.mineable || 'No'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.premined')}
				<span class="value">{coinInfo.premined || 'No'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.icoPriceUSD')}
				<span class="value">{coinInfo.icoPriceUSD ?? '-'}</span>
			</li>
		</ul>
		<ul class="right-side">
			<li class="text">
				{$_('coinDetailed.coinAbout.icoPriceETH')}
				<span class="value">{coinInfo.icoPriceETH ?? '-'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.icoPriceBTC')}
				<span class="value">{coinInfo.icoPriceBTC ?? '-'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.icoPriceDate')}
				<span class="value">{coinInfo.icoStartDate ?? '-'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.icoEndDate')}
				<span class="value">{coinInfo.icoEndDate ?? '-'}</span>
			</li>
			<li class="text">
				{$_('coinDetailed.coinAbout.totalUSDRaised')}
				<span class="value">{coinInfo.totalRaisedUSD ?? '-'}</span>
			</li>
		</ul>
	</div>
</div>

<style lang="scss">
	@import 'aboutCoin';
</style>
